<h2 mat-dialog-title class="helperTitle desktop">{{ 'VEHICLE_INFO.VIN_PLATE_HELPER_TITLE_DESKTOP' | translate }}</h2>

<div class="vinPlateHelper desktop" [ngStyle]="{ 'background' : 'url(' + vinPlateHelperImageMobileTwo + ')' }"></div>

<h2 mat-dialog-title class="helperTitle mobile">{{ 'VEHICLE_INFO.VIN_PLATE_HELPER_TITLE_2' | translate }}</h2>

<div class="vinPlateHelper mobile" [ngStyle]="{ 'background' : 'url(' + vinPlateHelperImageMobileTwo + ')' }"></div>

<button class="btn btn-primary parkingpass-nav" (click)="close()">
   {{ 'BUTTONS.CLOSE' | translate }}
</button>